var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTowerAviationObstructionLightL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 272,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 887,
    y: 171,
    width: 271,
    height: 272
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-887 -171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.431 59.5635 211.436 35.5688 135.5 111.505 59.5635 35.5688 35.5688 59.5635 111.505 135.5 35.5688 211.436 59.5635 235.431 135.5 159.495 211.436 235.431 235.431 211.436 159.495 135.5Z",
    fill: "#222222",
    transform: "matrix(1 0 0 1.00369 887 171)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerAviationObstructionLightL);
export default __webpack_public_path__ + "static/media/TowerAviationObstructionLightL.bc7b48b8451425cf566bc093423011b1.svg";
export { ForwardRef as ReactComponent };